import { FeatureSection } from "./components/sections/FeatureSection";
import { Footer } from "./footer/NewFooter";
import { Hero } from "./signature_collection/components/Hero";
import ProviderNavigation from "../ProviderNavigation";
import { getFeatureSections } from "./signature_collection/config/signatureCollectionConfig";

export default function SignatureCollectionPage() {
  const featureSections = getFeatureSections();

  return (
    <div className="tw-relative tw-min-h-screen tw-overflow-x-hidden">
      <div className="tw-bg-[url('/landing_page_assets/backgrounds/bg5.png')] tw-bg-cover tw-bg-right-bottom">
        <ProviderNavigation isDark />
        <div className="tw-relative tw-mx-auto tw-mt-[48px] tw-max-w-[1448px] tw-px-[20px]">
          <div className="tw-flex tw-h-full tw-flex-col tw-gap-y-[64px] tw-pb-[4em]">
            <Hero />
          </div>
        </div>
      </div>
      <div className="tw-relative tw-mx-auto tw-flex tw-h-full tw-max-w-[1448px] tw-flex-col tw-gap-y-[80px] tw-overflow-hidden tw-px-[24px] tw-py-[56px] min440:tw-gap-y-[120px] min440:tw-px-[76px]">
        {featureSections.map((section, index) => (
          <FeatureSection
            key={`feature-section-${index}`}
            {...section}
            className={section.className}
          />
        ))}
      </div>
      <Footer
        title="Get started with"
        titleAccent="Verse"
        description="Request and track provider signatures, all in one place."
        isRounded
        hasSquiggle
        buttonText="Get started"
        buttonClassName="tw-w-[15em]"
      />
    </div>
  );
}
